import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { GameSettingsKeys, useGameSetting } from '../util/UseGameSetting';
import { Toggle } from './Toggle';
import { Image } from './Image';
export var RenderingModeSetting;
(function (RenderingModeSetting) {
    RenderingModeSetting["ThreeJS"] = "ThreeJS";
    RenderingModeSetting["React"] = "React";
})(RenderingModeSetting || (RenderingModeSetting = {}));
export const RenderingModeCheckbox = ({ gameIndex }) => {
    const [renderingMode, setRenderingMode] = useGameSetting(`${GameSettingsKeys.RenderingMode}${gameIndex}`);
    const onToggleChanged = React.useCallback((checked) => {
        const shouldBeChecked = renderingMode === RenderingModeSetting.ThreeJS;
        if (shouldBeChecked !== checked) {
            setRenderingMode(checked ? RenderingModeSetting.ThreeJS : RenderingModeSetting.React);
        }
    }, [setRenderingMode]);
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'row', columnGap: '9px', margin: 'auto 0 auto auto', height: '100%' }, children: [_jsx(Image, { src: 'images/SquareWireframeIcon.png', style: { height: '22%', margin: 'auto 0' } }), _jsx("div", { style: { margin: 'auto 0' }, children: _jsx(Toggle, { onToggleChanged: onToggleChanged, checked: renderingMode === RenderingModeSetting.ThreeJS }) }), _jsx(Image, { src: 'images/CubeWireframeIcon.png', style: { height: '30%', margin: 'auto 0' } })] }));
};
//# sourceMappingURL=RenderingModeCheckbox.js.map